import React from "react";
import useCreateCompanyDepartmentModal from "./useCreateCompanyDepartmentModal";
import CompanyDepartmentFormModal from "./CompanyDepartmentFormModal";
import Resources from "../../types/Resources";

export type CreateCompanyDepartmentModalProps = {
    companyId: string;
    resources: Resources;
    show: boolean;
    canManageIsEnergyHarbourCustomer: boolean;
    onDepartmentCreated: () => void;
    onHide: () => void;
};

function CreateCompanyDepartmentModal(props: CreateCompanyDepartmentModalProps) {
    const modalContent = useCreateCompanyDepartmentModal(props);

    return (
        <CompanyDepartmentFormModal
            formState={modalContent.companyDepartmentFormState}
            onNameChange={modalContent.handleNameChange}
            onIsEnergyHarbourCustomerChange={modalContent.handleIsEnergyHarbourCustomerChange}
            canManageIsEnergyHarbourCustomer={props.canManageIsEnergyHarbourCustomer}
            onSubmit={modalContent.handleSubmitAsync}
            disableSubmit={modalContent.disableSubmit}
            modalHeader={props.resources.get("CreateCompanyDepartment") ?? ""}
            onHide={props.onHide}
            show={props.show}
            resources={props.resources}
            isLoading={false}
        />
    );
}

export default CreateCompanyDepartmentModal;
